import { atom, RecoilState } from 'recoil';
import { Visit, VisitTemplate } from 'api/models';

export const visitListState: RecoilState<Visit[]> = atom<Visit[]>({
  key: 'visitList',
  default: [],
});

export const visitTemplateListState: RecoilState<VisitTemplate[]> = atom<
  VisitTemplate[]
>({
  key: 'visitTemplateList',
  default: [],
});

export const selectedVisitTemplateState: RecoilState<VisitTemplate | null> =
  atom<VisitTemplate | null>({
    key: 'selectedVisitTemplate',
    default: null,
  });
